import React from 'react';
import { Link } from 'react-router-dom';
import { SYNEURAL_URL } from '../../data/navigation';
export function LogoMark({
  className = 'h-7 w-7'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 28 28" className={className} aria-hidden="true" data-id="element-87" data-mp="19wfp8te21lfe">
      <rect width="28" height="28" rx="8" fill="#0A1020" data-id="element-88" data-mp="19umh19nsmt5a" />
      <path d="M8.5 19.5V8.5L19.5 19.5V8.5" stroke="#fff" strokeWidth="1.6" fill="none" strokeLinejoin="round" data-id="element-89" data-mp="14wkzit60n1vx" />
      <circle cx="8.5" cy="19.5" r="2" fill="#fff" data-id="element-90" data-mp="1ivsx5hmj61y0" />
      <circle cx="8.5" cy="8.5" r="2" fill="#fff" data-id="element-91" data-mp="1dykbh726bfs0" />
      <circle cx="19.5" cy="19.5" r="2" fill="#fff" data-id="element-92" data-mp="1dy0v3us68zg3" />
      <circle cx="19.5" cy="8.5" r="2.4" fill="#5B85FF" data-id="element-93" data-mp="1snq94qld4xxs" />
    </svg>;
}
export function BrandLockup() {
  return <div className="flex items-baseline gap-2" data-id="element-94" data-mp="1np5b8xtl2qci">
      <Link to="/" aria-label="Noetivra home" className="flex items-center gap-2.5 self-center rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40" data-id="element-95" data-mp="1nqgemwj49w33">
        <LogoMark data-id="element-96" data-mp="1boizwffifk3n" />
        <span className="text-[17px] font-semibold tracking-tight text-ink" data-id="element-97" data-mp="1bp16a4vvzepa">Noetivra</span>
      </Link>
      <a href={SYNEURAL_URL} target="_blank" rel="noopener noreferrer" className="hidden text-xs text-ink-muted transition-colors duration-150 hover:text-ink sm:inline" data-id="element-98" data-mp="1fp2zrqrgx1th">
        by SyNeural
      </a>
    </div>;
}